// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const AddApp = createSvgIcon(
  { LeftToRight: <React.Fragment><rect width="22" height="22" x="1" y="1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" rx="2" /><path stroke="currentColor" strokeWidth="2" d="M1 7h22" /><circle cx="4" cy="4" r=".5" stroke="currentColor" /><circle cx="7" cy="4" r=".5" stroke="currentColor" /><circle cx="10" cy="4" r=".5" stroke="currentColor" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 12v6M15 15H9" /></React.Fragment>, },
  'default'
);
